import api from './client';
import type {
  AcceptDashboardShareResponse,
  ChartDataResponse,
  FilterDataResponse,
  PublicDashboard,
  SharedDashboardListResponse,
} from './types';

export const sharedDashboardsService = {
  accept: (token: string): Promise<AcceptDashboardShareResponse> =>
    api.post(`/shared-dashboards/accept/${encodeURIComponent(token)}`, {}),

  list: (): Promise<SharedDashboardListResponse> => api.get('/shared-dashboards'),

  remove: (dashboardId: string): Promise<void> =>
    api.delete(`/shared-dashboards/${encodeURIComponent(dashboardId)}`),

  getDashboard: (dashboardId: string): Promise<PublicDashboard> =>
    api.get(`/shared-dashboards/${encodeURIComponent(dashboardId)}`),

  getChartData: (
    dashboardId: string,
    chartId: string,
    filters: Record<string, unknown>,
  ): Promise<ChartDataResponse> => api.post(
    `/shared-dashboards/${encodeURIComponent(dashboardId)}/charts/${encodeURIComponent(chartId)}/data`,
    { filters },
  ),

  getFilterData: (
    dashboardId: string,
    filterId: string,
    options?: { search?: string; limit?: number; offset?: number },
  ): Promise<FilterDataResponse> => {
    const params = new URLSearchParams();
    if (options?.search) params.set('search', options.search);
    if (options?.limit != null) params.set('limit', String(options.limit));
    if (options?.offset != null) params.set('offset', String(options.offset));
    const query = params.toString();
    return api.get(
      `/shared-dashboards/${encodeURIComponent(dashboardId)}/filters/${encodeURIComponent(filterId)}/data${query ? `?${query}` : ''}`,
    );
  },
};